/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { Map } from 'immutable';
import SkillsDetailsPanel from './layout';
import {
  userHasUpdatePermission,
  isEntityFetching,
  userHasPermissions,
  userHasEveryPermissions,
  itemApiPending,
  getSelectedEntity,
} from '../../../redux/modules/entities/selectors';
import {
  setSelectedSubEntityId,
  toggleListItemEntity,
  setPendingProficiency,
  updateProficiency,
} from '../../../redux/modules/entities';
import { getSidePanelTableItems } from '../../../redux/modules/entities/listItemSelectors';
import { getSkillMemberSidePanelTableItems } from '../../../redux/modules/entities/skills/selectors';
import { entitiesMetaData } from '../../../redux/modules/entities/metaData';
import { getCurrentFormValueByFieldName } from '../../../redux/modules/form/selectors';

export function mapStateToProps(state) {
  return {
    pendingProficiencies: getSelectedEntity(state).get('pendingProficiencies') || new Map(),
    userHasUpdatePermission: userHasUpdatePermission(state),
    usersItems: getSkillMemberSidePanelTableItems(state),
    usersFields: entitiesMetaData.users.memberListTableFields,
    hasProficiency: getCurrentFormValueByFieldName(state, 'hasProficiency'),
    userCanRemoveProficiency: userHasPermissions(state, ['MANAGE_ALL_USER_SKILLS']),
    userCanManageProficiency: userHasPermissions(state, ['MANAGE_SKILL_PROFICIENCY']),
    usersFetching: isEntityFetching(state, 'users'),
    outboundIdentifierListsItems: getSidePanelTableItems(state, 'outboundIdentifierLists'),
    outboundIdentifierListsFields: entitiesMetaData.outboundIdentifierLists.memberListTableFields,
    outboundIdentifierListsFetching: isEntityFetching(state, 'outboundIdentifierLists'),
    defaultFilters: entitiesMetaData.skills.defaultAssociationFilters,
    itemApiPending: itemApiPending(state),
    sidePanelReadPermissions: {
      users:
        userHasPermissions(state, ['MANAGE_SKILL_PROFICIENCY']) ||
        userHasEveryPermissions(state, ['VIEW_ALL_SKILLS', 'VIEW_ALL_SKILL_USERS']),
      outboundIdentifierLists: userHasPermissions(state, ['OUTBOUND_IDENTIFIER_READ']),
    },
    sidePanelUpdatePermissions: {
      users: userHasPermissions(state, ['MANAGE_SKILL_PROFICIENCY']),
      outboundIdentifierLists: userHasPermissions(state, ['OUTBOUND_IDENTIFIER_ASSIGN']),
    },
  };
}

export const actions = {
  removeListItem: toggleListItemEntity,
  setSelectedSubEntityId,
  setPendingProficiency,
  updateProficiency,
};

export default connect(mapStateToProps, actions)(SkillsDetailsPanel);
